//Lists
const requestSort = (key, sortConfig, setSortConfig) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
        direction = 'descending';
    } else {
        direction = 'ascending';
    }
    setSortConfig({ key, direction });
};

const sortConfig = {
    key: null,
    direction: 'ascending',
};

const sortedAndFilteredData = (data, sortConfig, filter, isError, setIsError) => {
    let sortableItems = [...data];
    try {
        if (filter) {
            sortableItems = sortableItems.filter((item) =>
                Object.keys(item).some((header) => item[header]?.toString().toLowerCase().includes(filter.toLowerCase()))
            );
        }
    } catch (error) {
        console.log(error);
        error ? setIsError((st) => true) : setIsError((st) => false);
        console.log(isError);
    }
    if (sortConfig.key !== null) {
        sortableItems.sort((a, b) => {
            if (a[sortConfig.key] < b[sortConfig.key]) {
                return sortConfig.direction === 'ascending' ? -1 : 1;
            }
            if (a[sortConfig.key] > b[sortConfig.key]) {
                return sortConfig.direction === 'ascending' ? 1 : -1;
            }
            return 0;
        });
    }
    return sortableItems;
};

const downloadCSV = (data, filename = "export.csv") => {

  const csv = convertToCSV(data);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const getToday = () => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  return `${yyyy}${mm}${dd}`;
};

const convertToCSV = (objArray) => {
  const array = Array.isArray(objArray) ? objArray : [objArray];
  const keys = Object.keys(array[0]);

  const header = keys.join(",");
  const rows = array.map(row => 
    keys.map(k => JSON.stringify(row[k], replacer)).join(",")
  );

  return [header, ...rows].join("\n");
};

// Ensure values are properly escaped
const replacer = (key, value) => value === null ? '' : value;



const componentFunctions = { sortConfig, requestSort, sortedAndFilteredData, downloadCSV, getToday };

export default componentFunctions;
